(() => {
  if (!document.body.classList.contains('fuja-speed-page')) return;
  const root = document.documentElement;
  let cookieBanner;
  let previewBar;
  let frame;
  const height = (element) => {
    if (!element || getComputedStyle(element).visibility === 'hidden') return 0;
    return Math.ceil(element.getBoundingClientRect().height);
  };
  const update = () => {
    frame = undefined;
    root.style.setProperty('--fuja-preview-height', `${height(previewBar)}px`);
    root.style.setProperty('--fuja-cookie-height', `${height(cookieBanner)}px`);
  };
  const schedule = () => {
    if (frame === undefined) frame = requestAnimationFrame(update);
  };
  const sizeObserver = new ResizeObserver(schedule);
  const visibilityObserver = new MutationObserver(schedule);
  const connect = () => {
    const nextCookie = document.getElementById('shopify-pc__banner');
    const nextPreview = document.getElementById('PBarNextFrameWrapper');
    schedule();
    if (nextCookie === cookieBanner && nextPreview === previewBar) return;
    sizeObserver.disconnect();
    visibilityObserver.disconnect();
    cookieBanner = nextCookie;
    previewBar = nextPreview;
    for (const element of [cookieBanner, previewBar]) {
      if (!element) continue;
      sizeObserver.observe(element);
      visibilityObserver.observe(element, {attributes: true, attributeFilter: ['style', 'class', 'hidden']});
    }
    schedule();
  };
  new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
      node.nodeType === Node.ELEMENT_NODE &&
      (node.matches('#shopify-pc__banner, #PBarNextFrameWrapper') ||
       node.querySelector('#shopify-pc__banner, #PBarNextFrameWrapper'))))) connect();
  }).observe(document.body, {childList: true, subtree: true});
  window.addEventListener('resize', schedule, {passive: true});
  connect();
})();
